export default {
  fetching: state => {
    state.isLoading = true;
  },
  error: (state, { payload }) => {
    state.isLoading = false;
    state.error = payload;
  },
};
